import SetModulos from '../../Configuracion/SetModulos/SetModulos'
// 1 ) Objeto que se va guardar en el contexto 
const initialState = {
        Modulos : SetModulos.Modulos
};

// 2 ) Logica de manejo de la variable 
const autorizacionModReducer =  (state = initialState, action) =>{
switch (action.type) {
    case "MODULOS_AUTORIZACION":
        return{
            ...state,
            Modulos: action.autorizacionMod.Modulos
        }
    default : return state; 
}
}; 

//3 se exporta el comporamiento que administra la variable pra poder usarse 
export default autorizacionModReducer;